export const getServerError = (error: unknown) =>
  error instanceof Error
    ? error.message
    : typeof error === "string"
    ? error
    : error !== null && error !== undefined
    ? (error as any).toString()
    : "Error has occurred!";
